<template>
  <div id="states" class="text-xs-center">
    <v-card>
      <v-list class="panel">
        <v-list-group
          v-for="state in filteredStates"
          :key="state"
          sub-group
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title> 
                <span class="red-text"> {{ state }}</span> - {{stateReports(state).length}} homicidio{{stateReports(state).length>1 ? 's': ''}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile v-for="report in stateReports(state)" :key="report.folio">
            <v-list-tile-content @click="openPopUp(report.folio)">
              <v-list-tile-title class="report">{{report.folio}}. {{report.municipality}}, {{report.year}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "States",
  props: {},
  computed: {
    reports: {
      get () {
        return this.$store.state.filteredReports;
      }
    },
    filteredStates: {
      get () {
        return this.$store.state.filteredStates;
      },
      set (value) {
        this.$store.commit("setFilteredStates", value);
      }
    }
  },
  methods: {
    stateReports(state) {
      return this.reports.filter(el => {
        return el.state == state;
      }).sort((a,b) => {
        return (a.municipality - b.municipality) || (a.year - b.year);
      });
    },
    openPopUp(folio) {
      this.$store.commit("setSelection", folio);
    }
  }
};
</script>

<style>
#states .panel {
  height: 600px;
  overflow: scroll;
  border: 15px solid #eaeaea;
  padding: 0px;
  background-color: #f7f7f7;
}

.report {
  cursor: pointer;
}
.report:hover {
  text-decoration: underline;
}

.red-text {
  color: #be3117;
  font-weight: bold;
}

.v-expansion-panel__header {
  padding: 0px 24px;
}

.v-list__group__header--sub-group .v-list__group__header__prepend-icon {
  padding: 0 0 0 1rem;
  margin: 0;
}
.theme--light.v-expansion-panel .v-expansion-panel__container {
  background-color: #f7f7f7;
}

.v-list__group__header {
  background-color: #f7f7f7;
  border-bottom: 1px solid #acacac;
}
.v-list__tile__title {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 12px;
}

.v-list__group__items--no-action .v-list__tile {
  background-color: #f7f7f7;
  padding-left: 30px;
  border-bottom: 1px solid #acacac;
}
</style>
